import { render, staticRenderFns } from "./nav-group.vue?vue&type=template&id=68846fc8&scoped=true"
import script from "./nav-group.vue?vue&type=script&lang=js"
export * from "./nav-group.vue?vue&type=script&lang=js"
import style0 from "./nav-group.vue?vue&type=style&index=0&id=68846fc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68846fc8",
  null
  
)

export default component.exports